
import React from 'react';
import 'highlight.js/styles/tomorrow.css';
import myMarked from '@/utils/marked';
import styles from './markdown.module.less';

export default ({ docs = '' }) => {
    return <div className={styles.markdown} dangerouslySetInnerHTML={{ __html: myMarked(docs) }} />
}